export default __webpack_public_path__ + "static/media/Partner-Home-model.15d4c5c4.png";